<template>
  <div>
    <el-dialog class="registrationMethod" :visible.sync="welocomLogin" center title="欢迎加入心理亦笙" top="0"
               width="650px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="ordinary">
        <div class="tit">
          <img src="../assets/img/ordinary_a.png" alt="" width="97">
          <p>普通用户</p>
        </div>
        <div class="direction">如果您遇到<br/>这些困难</div>
        <div class="ordinaryList">
          <template v-for="(item , index) in ordinary">
            <div :style="'backgroundImage: url('+item.headImgPath+')'" class="mainImg" :key="index">
              <span>{{ item.tit }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="ordinary">
        <div class="tit">
          <img src="../assets/img/doct_a.png" alt="" width="97">
          <p>医生+咨询师</p>
        </div>
        <div class="direction">通过平台<br/>您可以做这些</div>
        <div class="ordinaryList">
          <template v-for="(item , index) in ordinaryDoctor">
            <div :style="'backgroundImage: url('+item.headImgPath+')'" class="mainImg" :key="index">
              <span>{{ item.tit }}</span>
            </div>
          </template>
        </div>
      </div>
      <h2 class="helpTit">我们可以为您提供</h2>
      <div class="help flex">
        <div class="helpList flex" v-for="(item , index) in helpList" :key="index">
          <div :style="'backgroundImage: url('+item.headImgPath+')'" class="mainImg"></div>
          <div class="desc">
            <span>{{ item.tit }}</span>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
      <div class="group">
        <router-link to="registered"><el-button>普通用户注册</el-button></router-link>
        <el-button style="margin-left: 20px;" @click="$refs.commonRes.registrationMethod=true">医生+咨询师注册</el-button>
      </div>
    </el-dialog>
    <commonRes ref="commonRes"></commonRes>
  </div>
 </template>

<script>
import commonRes from './famousDoctor/commonRes'
export default {
  name: "loginCommon",
  data() {
    return {
      welocomLogin: false,
      ordinary: [],
      ordinaryDoctor: [],
      helpList:[]
    }
  },
  mounted() {
    this.getordinary()
  },
  methods: {
    getordinary() {
      this.$ajax.get("./ordinary.json").then((res) => {
        this.ordinary = res.data.ordinary
        this.ordinaryDoctor = res.data.ordinaryDoctor
        this.helpList = res.data.helpList
      })
    }
  },
  components:{
    commonRes
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/loginCommon.scss';
</style>